<template>
  <el-form :model="form" ref="form" label-position="top">
    <el-row>
      <el-col :span="12">
        <el-form-item label="数据发送者ID" prop="as3From">
          <el-input v-model="form.as3From"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="数据接收者ID" prop="as3To">
          <el-input v-model="form.as3To"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="版本" prop="as3version">
          <el-input v-model="form.as3version"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="最大数据容量" prop="maxsize">
          <el-input-number v-model="form.maxsize"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="阈值" prop="threshold">
          <el-input-number v-model="form.threshold"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="限定扩展名" prop="speexts">
          <el-input v-model="form.speexts"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="限制扩展名" prop="excexts">
          <el-input v-model="form.excexts"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否自动命名" prop="autoname">
          <el-switch
            v-model="form.autoname"
            active-text="开"
            inactive-text="关">
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>

  import rApi from "@/api/senior/seniorconf";
  let datafault = {
  };
  export default {
    components: { rApi },
    props: {
      uuid:""
    },
    data() {
      return {
        form:{
          as3From:"",
          as3To:"",
          as3version:"1.2",
          maxsize:4194304,
          threshold:2000,
          speexts:"",
          excexts:"",
          autoname:false
        }
      };
    },
    mounted() {
      if(this.uuid){
        rApi.getPdSenior(this.uuid).then(resp=>{
          var _form = JSON.parse(resp.data);
          this.form.as3From = _form.as3From?_form.as3From:this.form.as3From;
          this.form.as3To = _form.as3To?_form.as3To:this.form.as3To;
          this.form.as3version = _form.as3version?_form.as3version:this.form.as3version;
          this.form.maxsize = _form.maxsize?_form.maxsize:this.form.maxsize;
          this.form.threshold = _form.threshold?_form.threshold:this.form.threshold;
          this.form.speexts = _form.speexts?_form.speexts:this.form.speexts;
          this.form.excexts = _form.excexts?_form.excexts:this.form.excexts;
          this.form.autoname = _form.autoname||_form.autoname===false?_form.autoname:this.form.autoname;
        });
      }
    },
    methods: {
      save(){
        if(this.uuid){
          rApi.doSaveForPdSenior(this.uuid,JSON.stringify(this.form)).then(()=>this.$message.success("操作成功！"));
        }
        return this.form;
      }
    }
  };
</script>
<style scoped>
</style>